export const alpha3to2 = {
  AND: 'AD',
  ARE: 'AE',
  AFG: 'AF',
  ATG: 'AG',
  AIA: 'AI',
  ALB: 'AL',
  ARM: 'AM',
  AGO: 'AO',
  ATA: 'AQ',
  ARG: 'AR',
  ASC: 'AC',
  ASM: 'AS',
  AUT: 'AT',
  AUS: 'AU',
  ABW: 'AW',
  ALA: 'AX',
  AZE: 'AZ',
  BIH: 'BA',
  BRB: 'BB',
  BGD: 'BD',
  BEL: 'BE',
  BFA: 'BF',
  BGR: 'BG',
  BHR: 'BH',
  BDI: 'BI',
  BEN: 'BJ',
  BLM: 'BL',
  BMU: 'BM',
  BRN: 'BN',
  BOL: 'BO',
  BES: 'BQ',
  BRA: 'BR',
  BHS: 'BS',
  BTN: 'BT',
  BVT: 'BV',
  BWA: 'BW',
  BLR: 'BY',
  BLZ: 'BZ',
  CAN: 'CA',
  CCK: 'CC',
  COD: 'CD',
  CAF: 'CF',
  COG: 'CG',
  CHE: 'CH',
  CIV: 'CI',
  COK: 'CK',
  CHL: 'CL',
  CMR: 'CM',
  CHN: 'CN',
  COL: 'CO',
  CRI: 'CR',
  CUB: 'CU',
  CPV: 'CV',
  CUW: 'CW',
  CXR: 'CX',
  CYP: 'CY',
  CZE: 'CZ',
  DEU: 'DE',
  DJI: 'DJ',
  DNK: 'DK',
  DMA: 'DM',
  DOM: 'DO',
  DZA: 'DZ',
  ECU: 'EC',
  EST: 'EE',
  EGY: 'EG',
  ESH: 'EH',
  ERI: 'ER',
  ESP: 'ES',
  ETH: 'ET',
  FIN: 'FI',
  FJI: 'FJ',
  FLK: 'FK',
  FSM: 'FM',
  FRO: 'FO',
  FRA: 'FR',
  GAB: 'GA',
  GBR: 'GB',
  GRD: 'GD',
  GEO: 'GE',
  GUF: 'GF',
  GGY: 'GG',
  GHA: 'GH',
  GIB: 'GI',
  GRL: 'GL',
  GMB: 'GM',
  GIN: 'GN',
  GLP: 'GP',
  GNQ: 'GQ',
  GRC: 'GR',
  SGS: 'GS',
  GTM: 'GT',
  GUM: 'GU',
  GNB: 'GW',
  GUY: 'GY',
  HKG: 'HK',
  HMD: 'HM',
  HND: 'HN',
  HRV: 'HR',
  HTI: 'HT',
  HUN: 'HU',
  IDN: 'ID',
  IRL: 'IE',
  ISR: 'IL',
  IMN: 'IM',
  IND: 'IN',
  IOT: 'IO',
  IRQ: 'IQ',
  IRN: 'IR',
  ISL: 'IS',
  ITA: 'IT',
  JEY: 'JE',
  JAM: 'JM',
  JOR: 'JO',
  JPN: 'JP',
  KEN: 'KE',
  KGZ: 'KG',
  KHM: 'KH',
  KIR: 'KI',
  COM: 'KM',
  KNA: 'KN',
  PRK: 'KP',
  KOR: 'KR',
  KWT: 'KW',
  CYM: 'KY',
  KAZ: 'KZ',
  LAO: 'LA',
  LBN: 'LB',
  LCA: 'LC',
  LIE: 'LI',
  LKA: 'LK',
  LBR: 'LR',
  LSO: 'LS',
  LTU: 'LT',
  LUX: 'LU',
  LVA: 'LV',
  LBY: 'LY',
  MAR: 'MA',
  MCO: 'MC',
  MDA: 'MD',
  MNE: 'ME',
  MAF: 'MF',
  MDG: 'MG',
  MHL: 'MH',
  MKD: 'MK',
  MLI: 'ML',
  MMR: 'MM',
  MNG: 'MN',
  MAC: 'MO',
  MNP: 'MP',
  MTQ: 'MQ',
  MRT: 'MR',
  MSR: 'MS',
  MLT: 'MT',
  MUS: 'MU',
  MDV: 'MV',
  MWI: 'MW',
  MEX: 'MX',
  MYS: 'MY',
  MOZ: 'MZ',
  NAM: 'NA',
  NCL: 'NC',
  NER: 'NE',
  NFK: 'NF',
  NGA: 'NG',
  NIC: 'NI',
  NLD: 'NL',
  NOR: 'NO',
  NPL: 'NP',
  NRU: 'NR',
  NIU: 'NU',
  NZL: 'NZ',
  OMN: 'OM',
  PAN: 'PA',
  PER: 'PE',
  PYF: 'PF',
  PNG: 'PG',
  PHL: 'PH',
  PAK: 'PK',
  POL: 'PL',
  SPM: 'PM',
  PCN: 'PN',
  PRI: 'PR',
  PSE: 'PS',
  PRT: 'PT',
  PLW: 'PW',
  PRY: 'PY',
  QAT: 'QA',
  REU: 'RE',
  ROU: 'RO',
  SRB: 'RS',
  RUS: 'RU',
  RWA: 'RW',
  SAU: 'SA',
  SLB: 'SB',
  SYC: 'SC',
  SDN: 'SD',
  SWE: 'SE',
  SGP: 'SG',
  SHN: 'SH',
  SVN: 'SI',
  SJM: 'SJ',
  SVK: 'SK',
  SLE: 'SL',
  SMR: 'SM',
  SEN: 'SN',
  SOM: 'SO',
  SUR: 'SR',
  SSD: 'SS',
  STP: 'ST',
  SLV: 'SV',
  SXM: 'SX',
  SYR: 'SY',
  SWZ: 'SZ',
  TAA: 'TA',
  TCA: 'TC',
  TCD: 'TD',
  ATF: 'TF',
  TGO: 'TG',
  THA: 'TH',
  TJK: 'TJ',
  TKL: 'TK',
  TLS: 'TL',
  TKM: 'TM',
  TUN: 'TN',
  TON: 'TO',
  TUR: 'TR',
  TTO: 'TT',
  TUV: 'TV',
  TWN: 'TW',
  TZA: 'TZ',
  UKR: 'UA',
  UGA: 'UG',
  UMI: 'UM',
  USA: 'US',
  URY: 'UY',
  UZB: 'UZ',
  VAT: 'VA',
  VCT: 'VC',
  VEN: 'VE',
  VGB: 'VG',
  VIR: 'VI',
  VNM: 'VN',
  VUT: 'VU',
  WLF: 'WF',
  WSM: 'WS',
  XKX: 'XK',
  YEM: 'YE',
  MYT: 'YT',
  ZAF: 'ZA',
  ZMB: 'ZM',
  ZWE: 'ZW',
};

export const fullNameTo2 = {
  'Ascension Island': 'AC',
  Andorra: 'AD',
  'United Arab Emirates': 'AE',
  'دولة الإمارات العربية المتحدة': 'AE',
  Afghanistan: 'AF',
  افغانستان: 'AF',
  'Antigua and Barbuda': 'AG',
  Anguilla: 'AI',
  Albania: 'AL',
  Shqipëria: 'AL',
  Armenia: 'AM',
  Հայաստան: 'AM',
  Angola: 'AO',
  Antarctica: 'AQ',
  Argentina: 'AR',
  'American Samoa': 'AS',
  Austria: 'AT',
  Österreich: 'AT',
  Australia: 'AU',
  Aruba: 'AW',
  Aland: 'AX',
  Åland: 'AX',
  Azerbaijan: 'AZ',
  Azərbaycan: 'AZ',
  'Bosnia and Herzegovina': 'BA',
  'Bosna i Hercegovina': 'BA',
  Barbados: 'BB',
  Bangladesh: 'BD',
  Belgium: 'BE',
  België: 'BE',
  'Burkina Faso': 'BF',
  Bulgaria: 'BG',
  България: 'BG',
  Bahrain: 'BH',
  '‏البحرين': 'BH',
  Burundi: 'BI',
  Benin: 'BJ',
  Bénin: 'BJ',
  'Saint Barthelemy': 'BL',
  'Saint-Barthélemy': 'BL',
  Bermuda: 'BM',
  Brunei: 'BN',
  'Negara Brunei Darussalam': 'BN',
  Bolivia: 'BO',
  Bonaire: 'BQ',
  Brazil: 'BR',
  Brasil: 'BR',
  Bahamas: 'BS',
  Bhutan: 'BT',
  'ʼbrug-yul': 'BT',
  'Bouvet Island': 'BV',
  Bouvetøya: 'BV',
  Botswana: 'BW',
  Belarus: 'BY',
  Беларусь: 'BY',
  Belize: 'BZ',
  Canada: 'CA',
  'Cocos (Keeling) Islands': 'CC',
  'Democratic Republic of the Congo': 'CD',
  'République démocratique du Congo': 'CD',
  'Central African Republic': 'CF',
  'Ködörösêse tî Bêafrîka': 'CF',
  'Republic of the Congo': 'CG',
  'République du Congo': 'CG',
  Switzerland: 'CH',
  Schweiz: 'CH',
  'Ivory Coast': 'CI',
  "Côte d'Ivoire": 'CI',
  'Cook Islands': 'CK',
  Chile: 'CL',
  Cameroon: 'CM',
  China: 'CN',
  中国: 'CN',
  Colombia: 'CO',
  'Costa Rica': 'CR',
  Cuba: 'CU',
  'Cape Verde': 'CV',
  'Cabo Verde': 'CV',
  Curacao: 'CW',
  Curaçao: 'CW',
  'Christmas Island': 'CX',
  Cyprus: 'CY',
  Κύπρος: 'CY',
  'Czech Republic': 'CZ',
  'Česká republika': 'CZ',
  Germany: 'DE',
  Deutschland: 'DE',
  Djibouti: 'DJ',
  Denmark: 'DK',
  Danmark: 'DK',
  Dominica: 'DM',
  'Dominican Republic': 'DO',
  'República Dominicana': 'DO',
  Algeria: 'DZ',
  الجزائر: 'DZ',
  Ecuador: 'EC',
  Estonia: 'EE',
  Eesti: 'EE',
  Egypt: 'EG',
  'مصر‎': 'EG',
  'Western Sahara': 'EH',
  'الصحراء الغربية': 'EH',
  Eritrea: 'ER',
  ኤርትራ: 'ER',
  Spain: 'ES',
  España: 'ES',
  Ethiopia: 'ET',
  ኢትዮጵያ: 'ET',
  Finland: 'FI',
  Suomi: 'FI',
  Fiji: 'FJ',
  'Falkland Islands': 'FK',
  Micronesia: 'FM',
  'Faroe Islands': 'FO',
  Føroyar: 'FO',
  France: 'FR',
  Gabon: 'GA',
  'United Kingdom': 'GB',
  Grenada: 'GD',
  Georgia: 'GE',
  საქართველო: 'GE',
  'French Guiana': 'GF',
  'Guyane française': 'GF',
  Guernsey: 'GG',
  Ghana: 'GH',
  Gibraltar: 'GI',
  Greenland: 'GL',
  'Kalaallit Nunaat': 'GL',
  Gambia: 'GM',
  Guinea: 'GN',
  Guinée: 'GN',
  Guadeloupe: 'GP',
  'Equatorial Guinea': 'GQ',
  'Guinea Ecuatorial': 'GQ',
  Greece: 'GR',
  Ελλάδα: 'GR',
  'South Georgia and the South Sandwich Islands': 'GS',
  'South Georgia': 'GS',
  Guatemala: 'GT',
  Guam: 'GU',
  'Guinea-Bissau': 'GW',
  'Guiné-Bissau': 'GW',
  Guyana: 'GY',
  'Hong Kong': 'HK',
  香港: 'HK',
  'Heard Island and McDonald Islands': 'HM',
  Honduras: 'HN',
  Croatia: 'HR',
  Hrvatska: 'HR',
  Haiti: 'HT',
  Haïti: 'HT',
  Hungary: 'HU',
  Magyarország: 'HU',
  Indonesia: 'ID',
  Ireland: 'IE',
  Éire: 'IE',
  Israel: 'IL',
  יִשְׂרָאֵל: 'IL',
  'Isle of Man': 'IM',
  India: 'IN',
  भारत: 'IN',
  'British Indian Ocean Territory': 'IO',
  Iraq: 'IQ',
  العراق: 'IQ',
  Iran: 'IR',
  ایران: 'IR',
  Iceland: 'IS',
  Ísland: 'IS',
  Italy: 'IT',
  Italia: 'IT',
  Jersey: 'JE',
  Jamaica: 'JM',
  Jordan: 'JO',
  الأردن: 'JO',
  Japan: 'JP',
  日本: 'JP',
  Kenya: 'KE',
  Kyrgyzstan: 'KG',
  Кыргызстан: 'KG',
  Cambodia: 'KH',
  កម្ពុជា: 'KH',
  Kiribati: 'KI',
  Comoros: 'KM',
  Komori: 'KM',
  'Saint Kitts and Nevis': 'KN',
  'North Korea': 'KP',
  북한: 'KP',
  'South Korea': 'KR',
  대한민국: 'KR',
  Kuwait: 'KW',
  الكويت: 'KW',
  'Cayman Islands': 'KY',
  Kazakhstan: 'KZ',
  Қазақстан: 'KZ',
  Laos: 'LA',
  ສປປລາວ: 'LA',
  Lebanon: 'LB',
  لبنان: 'LB',
  'Saint Lucia': 'LC',
  Liechtenstein: 'LI',
  'Sri Lanka': 'LK',
  'śrī laṃkāva': 'LK',
  Liberia: 'LR',
  Lesotho: 'LS',
  Lithuania: 'LT',
  Lietuva: 'LT',
  Luxembourg: 'LU',
  Latvia: 'LV',
  Latvija: 'LV',
  Libya: 'LY',
  '‏ليبيا': 'LY',
  Morocco: 'MA',
  المغرب: 'MA',
  Monaco: 'MC',
  Moldova: 'MD',
  Montenegro: 'ME',
  'Црна Гора': 'ME',
  'Saint Martin': 'MF',
  'Saint-Martin': 'MF',
  Madagascar: 'MG',
  Madagasikara: 'MG',
  'Marshall Islands': 'MH',
  M̧ajeļ: 'MH',
  'North Macedonia': 'MK',
  'Северна Македонија': 'MK',
  Mali: 'ML',
  'Myanmar (Burma)': 'MM',
  မြန်မာ: 'MM',
  Mongolia: 'MN',
  'Монгол улс': 'MN',
  Macao: 'MO',
  澳門: 'MO',
  'Northern Mariana Islands': 'MP',
  Martinique: 'MQ',
  Mauritania: 'MR',
  موريتانيا: 'MR',
  Montserrat: 'MS',
  Malta: 'MT',
  Mauritius: 'MU',
  Maurice: 'MU',
  Maldives: 'MV',
  Malawi: 'MW',
  Mexico: 'MX',
  México: 'MX',
  Malaysia: 'MY',
  Mozambique: 'MZ',
  Moçambique: 'MZ',
  Namibia: 'NA',
  'New Caledonia': 'NC',
  'Nouvelle-Calédonie': 'NC',
  Niger: 'NE',
  'Norfolk Island': 'NF',
  Nigeria: 'NG',
  Nicaragua: 'NI',
  Netherlands: 'NL',
  Nederland: 'NL',
  Norway: 'NO',
  Norge: 'NO',
  Nepal: 'NP',
  नेपाल: 'NP',
  Nauru: 'NR',
  Niue: 'NU',
  Niuē: 'NU',
  'New Zealand': 'NZ',
  Oman: 'OM',
  عمان: 'OM',
  Panama: 'PA',
  Panamá: 'PA',
  Peru: 'PE',
  Perú: 'PE',
  'French Polynesia': 'PF',
  'Polynésie française': 'PF',
  'Papua New Guinea': 'PG',
  'Papua Niugini': 'PG',
  Philippines: 'PH',
  Pilipinas: 'PH',
  Pakistan: 'PK',
  Poland: 'PL',
  Polska: 'PL',
  'Saint Pierre and Miquelon': 'PM',
  'Saint-Pierre-et-Miquelon': 'PM',
  'Pitcairn Islands': 'PN',
  'Puerto Rico': 'PR',
  Palestine: 'PS',
  فلسطين: 'PS',
  Portugal: 'PT',
  Palau: 'PW',
  Paraguay: 'PY',
  Qatar: 'QA',
  قطر: 'QA',
  Reunion: 'RE',
  'La Réunion': 'RE',
  Romania: 'RO',
  România: 'RO',
  Serbia: 'RS',
  Србија: 'RS',
  Russia: 'RU',
  Россия: 'RU',
  Rwanda: 'RW',
  'Saudi Arabia': 'SA',
  'المملكة العربية السعودية': 'SA',
  'Solomon Islands': 'SB',
  Seychelles: 'SC',
  Sudan: 'SD',
  السودان: 'SD',
  Sweden: 'SE',
  Sverige: 'SE',
  Singapore: 'SG',
  'Saint Helena': 'SH',
  Slovenia: 'SI',
  Slovenija: 'SI',
  'Svalbard and Jan Mayen': 'SJ',
  'Svalbard og Jan Mayen': 'SJ',
  Slovakia: 'SK',
  Slovensko: 'SK',
  'Sierra Leone': 'SL',
  'San Marino': 'SM',
  Senegal: 'SN',
  Sénégal: 'SN',
  Somalia: 'SO',
  Soomaaliya: 'SO',
  Suriname: 'SR',
  'South Sudan': 'SS',
  'Sao Tome and Principe': 'ST',
  'São Tomé e Príncipe': 'ST',
  'El Salvador': 'SV',
  'Sint Maarten': 'SX',
  Syria: 'SY',
  سوريا: 'SY',
  Eswatini: 'SZ',
  'Tristan da Cunha': 'TA',
  'Turks and Caicos Islands': 'TC',
  Chad: 'TD',
  Tchad: 'TD',
  'French Southern Territories': 'TF',
  'Territoire des Terres australes et antarctiques fr': 'TF',
  Togo: 'TG',
  Thailand: 'TH',
  ประเทศไทย: 'TH',
  Tajikistan: 'TJ',
  Тоҷикистон: 'TJ',
  Tokelau: 'TK',
  'East Timor': 'TL',
  'Timor-Leste': 'TL',
  Turkmenistan: 'TM',
  Türkmenistan: 'TM',
  Tunisia: 'TN',
  تونس: 'TN',
  Tonga: 'TO',
  Türkiye: 'TR',
  'Trinidad and Tobago': 'TT',
  Tuvalu: 'TV',
  Taiwan: 'TW',
  臺灣: 'TW',
  Tanzania: 'TZ',
  Ukraine: 'UA',
  Україна: 'UA',
  Uganda: 'UG',
  'U.S. Minor Outlying Islands': 'UM',
  'United States Minor Outlying Islands': 'UM',
  'United States': 'US',
  Uruguay: 'UY',
  Uzbekistan: 'UZ',
  "O'zbekiston": 'UZ',
  'Vatican City': 'VA',
  Vaticano: 'VA',
  'Saint Vincent and the Grenadines': 'VC',
  Venezuela: 'VE',
  'British Virgin Islands': 'VG',
  'U.S. Virgin Islands': 'VI',
  'United States Virgin Islands': 'VI',
  Vietnam: 'VN',
  'Việt Nam': 'VN',
  Vanuatu: 'VU',
  'Wallis and Futuna': 'WF',
  'Wallis et Futuna': 'WF',
  Samoa: 'WS',
  Kosovo: 'XK',
  'Republika e Kosovës': 'XK',
  Yemen: 'YE',
  اليَمَن: 'YE',
  Mayotte: 'YT',
  'South Africa': 'ZA',
  Zambia: 'ZM',
  Zimbabwe: 'ZW',
};
